import { useAuth } from "../../contexts/AuthContext";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { createUserInDatabase } from "../../utils/helper";

const loginSchema = yup.object().shape({
    email: yup.string().email().required(),
    password: yup.string().min(8).max(32).required(),
});
const signinSchema = yup.object().shape({
    email: yup
        .string()
        .email("L'email doit être valide")
        .required("L'email doit être renseigné"),
    password: yup
        .string()
        .min(8, "Le mot de passe doit contenir au moins 8 caractères")
        .max(32, "Le mot de passe ne peut contenir plus de 8 caractères")
        .required("Le mot de passe doit être renseigné"),
    text: yup
        .string()
        .min(5, "Le pseudo doit contenir au moins 5 caractères")
        .max(15)
        .required(),
});

const SignAndLogForm = ({ type = "log" }) => {

    const { loginWithMail, signupWithMail } = useAuth();
    const navigate = useNavigate();

    const formCss = "flex flex-col gap-2 py-6"
    const inputCss = "w-full h-8 p-1 bg-ivory border border-darkYellow text-darkYellow placeholder:text-darkYellow autofill:text-darkYellow rounded"
    const pCss = "text-lg text-red-700"
    const btnCss = "w-full text-darkRed shadow-md shadow-darkRed hover:shadow-ivory font-bold bg-ivory hover:bg-darkRed hover:text-ivory rounded px-4 py-4 text-3xl"

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(type === "log" ? loginSchema : signinSchema),
    });
    const onSubmitHandler = (data) => {
        if (type === "log") {
            loginWithMail(data.email.trim(), data.password.trim())
                .then(() => {
                    navigate("/home");
                    // displayValidBox()
                })
                .catch((error) => {
                    // setHasError(error.message)
                    console.log(error)
                })
                .finally(() => {
                    // setIsSubmitting(false)
                });
        } else {
            signupWithMail(data.email.trim(), data.password.trim())
                .then(cred => {
                    createUserInDatabase(cred)
                }).then(
                    () => navigate("/home")
                    // displayValidBox()
                ).catch((error) => {
                    // setHasError(error.message)
                    console.log(error.message)
                }).finally(() => {
                    // setIsSubmitting(false)
                });
        }

        reset();
    };

    const form = type === "log" ? <>
        <form className={formCss} onSubmit={handleSubmit(onSubmitHandler)} >
            <input className={inputCss} placeholder="Email" type="email" required {...register("email")} />
            <p className={pCss}>{errors.email?.message}</p>
            <input className={inputCss} placeholder="Mot de passe" type="password" required {...register("password")} />
            <p className={pCss}>{errors.password?.message}</p>
            <p className="text-darkRed h-8 mb-2 cursor-pointer">Mot de passe oublié ?</p>
            <button type="submit" className={btnCss}>Continuer</button>
        </form>
    </> : <>
        <form className={formCss} onSubmit={handleSubmit(onSubmitHandler)} >
            <input className={inputCss} placeholder="Pseudo" type="text" required {...register("text")} />
            <p className={pCss}>{errors.text?.message}</p>
            <input className={inputCss} placeholder="Email" type="email" required {...register("email")} />
            <p className={pCss}>{errors.email?.message}</p>
            <input className={inputCss} placeholder="Mot de passe" type="password" required {...register("password")} />
            <p className={pCss}>{errors.password?.message}</p>
            <button type="submit" className={btnCss}>M'inscrire</button>
        </form>
    </>

    return (<>
        {form}
    </>
    )
}

export default SignAndLogForm